import { List, Datagrid, TextField, 
         FunctionField, 
         BooleanField} from 'react-admin';

export const FindingList = props => (
  <List {...props}>
    <Datagrid>
      <TextField source="id"/>
      <TextField source="account_id"/>
      <TextField source="vulnerability_type"/>
      <TextField source="name"/>
      <TextField source="affected_urls"/>
      <TextField source="description"/>
      <TextField source="payload"/>
      <TextField source="poc_image_path"/>
      <BooleanField source="used_threat_model"/>
      <TextField source="threat_model_info"/>
      <FunctionField source="updated_at" 
        render={
          record => {
            return new Date(record.updated_at + "Z").toLocaleString(undefined, {timeZoneName: "shortOffset"});
          }
        }
      />
      <TextField source="website_name"/>
    </Datagrid>
  </List>
);